<template>
  <el-row class="ta-header">
    <div class="ta-chart-header ta-chart-header__with-hint">
      {{$t('charts.rangeHoursRelative.title')}}
    </div>
    <div class="ta-chart-header ta-chart-header__small">
      {{$t('charts.rangeHoursRelative.description')}}
    </div>
    <div :id="id"/>
  </el-row>
</template>

<script>
import Highcharts from 'highcharts'

export default {
  name: 'RangeHoursRelative',
  props: {
    data: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  watch: {
    data () {
      if (this.data.userInput) {
        this.rerender()
      }
    }
  },
  methods: {
    rerender () {
      Highcharts.chart(this.id, {
        chart: {
          type: 'pie',
          backgroundColor: '#F1F6E4'
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '{point.percentage:.1f} %'
            },
            showInLegend: true
          }
        },
        title: {
          text: ''
        },
        series: this.getSeries()
      })
    },
    getSeries () {
      const values = []
      const series = []
      for (const zone of this.data.userInput.hours.zones) {
        let totalTime = 0
        for (const range of zone.ranges) {
          totalTime += range.value
        }
        values.push({
          name: this.$t('charts.labels.zones.' + zone.label),
          y: totalTime
        })
      }
      series.push({
        name: this.$t('charts.rangeHoursRelative.label'),
        colorByPoint: true,
        data: values
      })
      return series
    }
  }
}
</script>

<style scoped>

</style>
